<template>
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clip-rule="evenodd"
      d="M8.72972 5.77109L5.66758 9.91412C4.38285 11.6524 3.74049 12.5215 4.09444 13.2048C4.1003 13.2162 4.10634 13.2274 4.11255 13.2385C4.4875 13.9115 5.59693 13.9115 7.8158 13.9115C9.04884 13.9115 9.66535 13.9115 10.052 14.2752L10.0721 14.2944L13.944 9.72442L13.924 9.70517C13.5454 9.33362 13.5455 8.74127 13.5455 7.55658V7.24688C13.5455 3.96225 13.5454 2.31994 12.6221 2.03697C11.6987 1.75401 10.7091 3.09303 8.72972 5.77109Z"
      fill="#194BFB"
      fill-rule="evenodd"
    />
    <path
      d="M10.4508 16.4427V16.7523C10.4508 20.0369 10.4508 21.6793 11.3741 21.9622C12.2975 22.2452 13.2872 20.9062 15.2666 18.2281L18.3287 14.0851C19.6135 12.3469 20.2558 11.4778 19.9019 10.7944C19.896 10.7831 19.89 10.7719 19.8838 10.7608C19.5088 10.0878 18.3994 10.0878 16.1805 10.0878C14.9475 10.0878 14.331 10.0878 13.9443 9.72412L10.0723 14.2941C10.4509 14.6656 10.4508 15.258 10.4508 16.4427Z"
      fill="#194BFB"
      opacity="0.5"
    />
  </svg>
</template>

<script>
export default {
  name: 'NlpWhySatoshiIcon2',
}
</script>